const schema = {
    date: {
        id: 'date',
        label: 'Data de troca',
        help: '',
        mask: '',
        required: true,
        type: 'date',
        requiredMessage: 'Preencha a data de troca de plano'
    },
    newHealthPlan: {
        id: 'newHealthPlan',
        label: 'Novo plano',
        help: '',
        mask: '',
        required: true,
        type: 'select',
        requiredMessage: 'Selecione o novo plano',
        options: [],
    },
    state: {
        id: 'state',
        label: 'Estado de atendimento',
        required: false,
        placeholder: 'Selecione',
        type: 'select',
    },
    city: {
        id: 'city',
        label: 'Município de atendimento',
        required: false,
        type: 'select',
        options: [],
    },
};

export default schema;
